import {
  RBAC_BULK_REASSIGN_ROLE_REQUIRED_MESSAGE,
  RBAC_BULK_REASSIGN_SUBMIT_ERROR_MESSAGE
} from './constants'

export function getRbacBulkSubmitErrorMessage(error) {
  return error?.message || RBAC_BULK_REASSIGN_SUBMIT_ERROR_MESSAGE
}

export function buildRbacBulkAssignments(selectedIds, roleByUserId) {
  const nextErrors = {}
  const assignments = []

  selectedIds.forEach((userId) => {
    const roleIds = roleByUserId[userId] || []
    if (!roleIds.length) {
      nextErrors[userId] = RBAC_BULK_REASSIGN_ROLE_REQUIRED_MESSAGE
      return
    }

    assignments.push({ user_id: Number(userId), role_ids: roleIds })
  })

  return { assignments, nextErrors }
}
